import { QuestionType } from "../types/questionType";
import { TemplateEnum } from "../types/templateEnum";

export const isEndBlock = (question: QuestionType) => {
  return question.answerTemplate?.type === TemplateEnum.END_BLOCK && !!question.endBlock;
};
